import { render, staticRenderFns } from "./RedirectAlert.vue?vue&type=template&id=7c7340f6&scoped=true"
import script from "./RedirectAlert.vue?vue&type=script&lang=js"
export * from "./RedirectAlert.vue?vue&type=script&lang=js"
import style0 from "./RedirectAlert.vue?vue&type=style&index=0&id=7c7340f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7340f6",
  null
  
)

export default component.exports